/**
 * 견적서 관련 포맷팅 유틸리티
 */

/**
 * 금액 포맷팅 (원 단위)
 */
export function formatAmount(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '0원'
  return `${amount.toLocaleString('ko-KR')}원`
}

/**
 * 금액 마스킹 (권한 없을 때)
 */
export function maskAmount(): string {
  return '•••••원'
}

/**
 * 날짜 포맷팅 (YYYY-MM-DD 또는 ISO 문자열 → YYYY년 MM월 DD일)
 * 시간 정보가 있으면 시간도 표시
 */
export function formatDate(date: string | null | undefined): string {
  if (!date) return ''
  
  try {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    
    // 시간 정보가 있는지 확인 (ISO 문자열에 T가 포함되어 있으면 시간 정보 있음)
    const hasTime = date.includes('T') && !date.endsWith('T00:00:00.000Z')
    
    if (hasTime) {
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${year}년 ${month}월 ${day}일 ${hours}:${minutes}`
    }
    
    return `${year}년 ${month}월 ${day}일`
  } catch {
    return date
  }
}

/**
 * 날짜 포맷팅 (짧은 형식: MM월 DD일)
 */
export function formatDateShort(date: string | null | undefined): string {
  if (!date) return ''
  
  try {
    const d = new Date(date)
    const month = d.getMonth() + 1
    const day = d.getDate()
    return `${month}월 ${day}일`
  } catch {
    return date
  }
}

/**
 * 상대 시간 포맷팅 (예: 3일 전)
 */
export function formatRelativeTime(date: string | null | undefined): string {
  if (!date) return ''
  
  try {
    const d = new Date(date)
    const now = new Date()
    const diffMs = now.getTime() - d.getTime()
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    
    if (diffDays === 0) return '오늘'
    if (diffDays === 1) return '어제'
    if (diffDays < 7) return `${diffDays}일 전`
    if (diffDays < 30) return `${Math.floor(diffDays / 7)}주 전`
    if (diffDays < 365) return `${Math.floor(diffDays / 30)}개월 전`
    return `${Math.floor(diffDays / 365)}년 전`
  } catch {
    return formatDateShort(date)
  }
}

/**
 * 텍스트 줄임 (maxLength 초과 시 ...)
 */
export function truncateText(text: string | null | undefined, maxLength: number): string {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

/**
 * 제출 주체 포맷팅 (팀/개인 + 이름/팀명)
 * 형식: "개인 · 홍길동" 또는 "팀 · 링크ers AI 팀"
 */
export function formatProposer(
  teams: any[] | null | undefined,
  proposerType?: 'TEAM' | 'INDIVIDUAL',
  proposerName?: string | null
): string {
  // 팀인 경우
  if (proposerType === 'TEAM' || (teams && teams.length > 0)) {
    const teamName = teams?.[0]?.name
    if (teamName) {
      return `팀 · ${teamName}`
    }
    return '팀'
  }
  
  // 개인인 경우
  if (proposerType === 'INDIVIDUAL' || proposerName) {
    if (proposerName) {
      return `개인 · ${proposerName}`
    }
    return '개인'
  }
  
  // 기본값 (팀 정보가 없으면 개인으로 간주)
  return '개인'
}

